import React, { useState, useEffect } from 'react';
import { SimpleTableRow } from '../../tables/types';
import moment from 'moment';
import { kFormatter } from '../../containers/pivotHelper';
import LineGraph, { LineGraphConfig, ChartType } from '../../containers/LineGraph';
import { SwissColors } from '../../common/stylesConsts';
import { getFetcher } from '../../common/fetcher';
import { fetchConnector, FetchPNLAnalyticsPropsFromRedux } from '../dataFetcher';
import { getAuthUser } from '../../common/auth';

let graphConfig: LineGraphConfig = {
    title: '',
    dataKey: 'pipe_run_date',
    oyLabel: '',
    oxLabel: '',
    minHeight: '400px',
    xAxisFormatter: (d) => moment(d).format('DD MMM'),
    xTooltipFormatter: (d) => moment(d).format('ddd MMM Do YYYY'),
    yAxis: {
        yLimit: ['dataMin', 'dataMax'],
        yAxisFormatter: (v) => kFormatter(v, false, { billions: 2, millions: 1, thousands: 0, hundreds: 0 }),
    },
    yTooltipFormatter: (v) => kFormatter(v, false),
    chartsSettings: [{ chartType: ChartType.AreaAsLine, key: 'pnl', color: SwissColors.Orange, title: 'Deal LTD PNL' }],
};

type DealModalGraphProps = FetchPNLAnalyticsPropsFromRedux & {
    row: SimpleTableRow;
};

const graphContainerStyles: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    border: '2px solid #000',
    boxShadow: '24',
    backgroundColor: '#fff',
    width: '650px',
    height: '450px',
};

export const DealModalGraph = ({ row, pnlAnalytics, authUser }: DealModalGraphProps) => {
    const [loading, setLoading] = useState(true);
    const [dealPnlData, setDealPnlData] = useState<any[]>([]);
    const deal = (row.deal as string).split(' ').slice(1).join(' ');
    const pipeRunDate = pnlAnalytics.meta.data?.selected.pipe_run_date;

    useEffect(() => {
        if (deal && pipeRunDate) {
            setLoading(true);
            getFetcher({
                url: `/pnl_analytics/deal_pnl/date/${pipeRunDate}`,
                params: { deal: deal },
                headers: {
                    'Swiss-Tech-Auth-Token': getAuthUser(authUser).swiss_token,
                },
                onSuccess: (response) => {
                    const data = (response as { deal_pnl: any[] }).deal_pnl;
                    if (response && data) {
                        setDealPnlData(data);
                    }
                    setLoading(false);
                },
                onFail: (error) => {
                    setLoading(false);
                },
            });
        }
    }, [deal, pipeRunDate, authUser]);

    if (loading) {
        return <span>Loading deal LTD PNL data...</span>;
    }
    return (
        <div style={graphContainerStyles}>
            <LineGraph {...graphConfig} values={dealPnlData || []} />
        </div>
    );
};

export default fetchConnector(DealModalGraph);
